<template>
  <div>
    <div v-if="isOpen" class="fixed inset-0 z-30 bg-black/40 lg:hidden" @click="$emit('close')"></div>
    <aside :class="[
      'fixed top-0 left-0 z-40 h-screen shadow border-r transition-all ease-in-out overflow-y-auto ',
      isCompact ? 'w-20' : 'w-[270px]',
      'bg-primary-bg text-primary-text dark:text-gray-100 border-light-border dark:bg-primary-dark-bg dark:border-dark-border',
      isOpen ? 'translate-x-0' : '-translate-x-full',
      'lg:translate-x-0 lg:static'
    ]">
      <div class="flex justify-end p-3">
        <button @click="isCompact = !isCompact"
          class="text-secondary-text hover:text-gray-500 dark:text-gray-300 dark:hover:text-white">
          <ChevronDoubleLeftIcon v-if="!isCompact" class="w-6 h-6" />
          <ChevronDoubleRightIcon v-else class="w-6 h-6" />
        </button>
      </div>

      <div class="flex justify-end p-3 lg:hidden">
        <button @click="$emit('close')"
          class="text-secondary-text hover:text-gray-500 dark:text-gray-300 dark:hover:text-white">
          <XMarkIcon class="w-6 h-6" />
        </button>
      </div>

      <div class="flex items-center justify-center pt-4">
        <img src="../assets/images/uslu-logo.png" alt="Logo"
          :class="[isCompact ? ' hidden ' : 'px-4 py-1 dark:bg-gray-700', 'transition-all duration-300']" />
      </div>

      <nav class="flex-1 overflow-y-auto space-y-2 px-2 py-6 mt-5">
        <router-link v-for="(item, index) in menuItems" :key="index" :to="item.to" @click="$emit('close')" :class="[
          'flex items-center rounded-md text-sm font-medium transition-colors relative group ',
          isCompact ? 'justify-center p-3' : 'gap-3 px-4 py-2',
          'text-primary-text hover:bg-indigo-100 hover:text-indigo-700 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white'
        ]" active-class="bg-indigo-200 text-indigo-800 font-semibold dark:bg-gray-700 dark:text-white">

          <component :is="item.icon" class="w-7 h-7" />

          <span v-if="isCompact"
            class="absolute -top-5 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-indigo-200 text-primary-text dark:bg-gray-800 dark:text-white text-xs px-2 py-1 rounded">
            {{ item.label }}
          </span>
          <span v-if="!isCompact">{{ item.label }}</span>
        </router-link>
      </nav>
    </aside>
  </div>
</template>

<script>
import {
  HomeIcon,
  BuildingStorefrontIcon,
  ShoppingBagIcon,
  CubeIcon,
  Cog6ToothIcon,
  ExclamationCircleIcon,
  TruckIcon,
  UserPlusIcon,
  DocumentChartBarIcon,
  BuildingOfficeIcon,
  CircleStackIcon,
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  CalculatorIcon,
  XMarkIcon,
  CreditCardIcon
} from '@heroicons/vue/24/outline'
import { ArrowsRightLeftIcon } from '@heroicons/vue/24/solid';

export default {
  name: "AppSidebar",
  components: {
    HomeIcon,
    BuildingStorefrontIcon,
    ShoppingBagIcon,
    CubeIcon,
    Cog6ToothIcon,
    ExclamationCircleIcon,
    TruckIcon,
    UserPlusIcon,
    DocumentChartBarIcon,
    BuildingOfficeIcon,
    ArrowsRightLeftIcon,
    CircleStackIcon,
    ChevronDoubleLeftIcon,
    ChevronDoubleRightIcon,
    CalculatorIcon,
    XMarkIcon,
    CreditCardIcon
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      isCompact: false,
      menuItems: [
        { label: "Ana Sayfa", to: "/", icon: "HomeIcon" },
        { label: "Tüm Siparişler", to: "/tum-siparisler", icon: "ArrowsRightLeftIcon" },
        { label: "Onay Bekleyenler", to: "/onay-bekleyenler", icon: "TruckIcon" },
        // { label: "Teslimatlar", to: "/teslimatlar", icon: "TruckIcon" },
        // { label: "Siparişler", to: "/siparisler", icon: "TruckIcon" },
        { label: "Bayiler", to: "/bayiler", icon: "BuildingOfficeIcon" },
        { label: "Sürücüler", to: "/suruculer", icon: "UserPlusIcon" },
        { label: "Ürünler", to: "/urunler", icon: "CubeIcon" },
        { label: "Cari Hesaplar", to: "/cari", icon: "CreditCardIcon" },
        // { label: "Stok", to: "/stok", icon: "ExclamationCircleIcon" },
        { label: "Kasa", to: "/kasa", icon: "BuildingStorefrontIcon" },
        { label: "Veri Analizi", to: "/analiz", icon: "DocumentChartBarIcon" },
        { label: "Hareketler", to: "/islemler", icon: "CircleStackIcon" }
      ]
    }
  }
}
</script>
